'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdMultilineChart = function MdMultilineChart(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm36.6 11.6l-5 5.7c1.8 2.9 3 6.4 3.4 10.2h-3.4c-0.3-2.7-1.1-5.3-2.4-7.6l-6.7 7.6-6.6-6.7-10 10-2.5-2.5 12.5-12.5 6.6 6.7 4.8-5.5c-2.9-3.3-6.8-5.4-11.3-5.4-3.9 0-7.5 1.6-10.3 4.1l-2.3-2.3c3.4-3.1 7.8-5 12.6-5 5.4 0 10.1 2.3 13.5 6.1l4.8-5.3z' })
        )
    );
};

exports.default = MdMultilineChart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/multiline-chart.js
// module id = 1246
// module chunks = 36573943044255 79611799117203 213534597649335